module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_302960.5153bec5.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetATF/FormatoSimplificado_302960.pdf
// module id = 326
// module chunks = 0